import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1119">
      <HeroSection data-id="element-1120" />
      <PainSection data-id="element-1121" />
      <TruthSection data-id="element-1122" />
      <ProductPresentation data-id="element-1123" />
      <ContentBreakdown data-id="element-1124" />
      <BenefitsSection data-id="element-1125" />
      <TestimonialsSection data-id="element-1126" />
      <ForYouSection data-id="element-1127" />
      <GuaranteeSection data-id="element-1128" />
      <BonusSection data-id="element-1129" />
      <ValueStack data-id="element-1130" />
      <FAQSection data-id="element-1131" />
      <ImpactPhrases data-id="element-1132" />
      <Footer data-id="element-1133" />
    </div>;
}